import { Box, Button, Typography } from '@mui/material';
import { ArrowCounterClockwise, ArrowRight } from '@phosphor-icons/react';
import KitModal from '../UI/KitModal';

interface RestoreConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  currentVersionName: string;
  restoreVersionName: string;
}

const RestoreConfirmModal = ({
  show,
  onHide,
  onConfirm,
  currentVersionName,
  restoreVersionName,
}: RestoreConfirmModalProps) => {
  return (
    <KitModal
      onHide={onHide}
      show={show}
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '560px',
          width: '100%',
        },
        '& .MuiDialogTitle-root': {
          mt: 4,
        },
        '& .MuiDialogTitle-root .MuiTypography-root': {
          color: '#101828',
          fontWeight: 600,
        },
      }}
      title={`Restore to ${restoreVersionName}`}
    >
      <Box
        display="flex"
        flexDirection="column"
        gap="1rem"
      >
        <Typography sx={{ fontSize: '14px', color: '#667085', mt: -1.5 }}>
          This current version will be restored to {restoreVersionName}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: 2,
            py: 1.5,
            borderRadius: '8px',
            border: '1px solid #12B76A',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: '#F79009',
              }}
            />
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#344054' }}>
              {currentVersionName}
            </Typography>
          </Box>
          <ArrowRight size={16} color="#667085" />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: '#12B76A',
              }}
            />
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#344054' }}>
              Replaced by {restoreVersionName}
            </Typography>
          </Box>
        </Box>

        <Box display="flex" gap="0.75rem">
          <Button
            onClick={onHide}
            variant="outlined"
            fullWidth
            sx={{
              textTransform: 'none',
              fontWeight: 500,
              borderRadius: '4px',
              py: 1,
              borderColor: '#D0D5DD',
              color: '#344054',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            fullWidth
            startIcon={<ArrowCounterClockwise size={18} />}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '4px',
              py: 1,
              bgcolor: '#546BEA',
              '&:hover': { bgcolor: '#3650DE' },
            }}
          >
            Restore
          </Button>
        </Box>
      </Box>
    </KitModal>
  );
};

export default RestoreConfirmModal;
